import { useMediaQuery } from '@mui/material'
import cx from 'classnames'
import React from 'react'

export const Spinner = () => {
  const isDesktopView = useMediaQuery('(min-width: 901px)')

  return (
    <>
      <p className='[ f-t-tminor f-t-bold f-t-centre ]'>
        Ihr Konto wird erstellt
      </p>
      <div className={cx('spinner', isDesktopView && 'spinner--inline')} />
    </>
  )
}
